import {
  CLEAR_TABLE_DATA
  INIT_TABLE_DATA
  SET_TABLE_DATA
} from './actionTypes'

export reducer = (state = {}, { type, payload }) ->
  switch (type)
    when CLEAR_TABLE_DATA
      {}
    when INIT_TABLE_DATA
      payload.data.reduce((acc, id) ->
        { acc..., [id]: undefined }
      , {})
    when SET_TABLE_DATA
      { state..., payload.data... }


